import React from "react";
import useDeleteJob from "../hooks/useDeleteJob";
import useJobLog from "../hooks/useJobLog";
import useJobs from "../hooks/useJobs";
import Toolbar from "./Toolbar";

String.prototype.toHHMMSS = function () {
  var sec_num = parseInt(this, 10); // don't forget the second param
  var hours   = Math.floor(sec_num / 3600);
  var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
  var seconds = sec_num - (hours * 3600) - (minutes * 60);

  if (hours   < 10) {hours   = "0"+hours;}
  if (minutes < 10) {minutes = "0"+minutes;}
  if (seconds < 10) {seconds = "0"+seconds;}
  return hours+':'+minutes+':'+seconds;
}

function Jobs() {
  const { jobsData, jobsError } = useJobs();
  const { fetchLogs, fetchingLogs } = useJobLog();
  const { deleteJob, jobDeleting } = useDeleteJob();

  const headers = [
    ["id", "id"],
    ["name", "name"],
    ["progress", "progress"],
    ["attemptsMade", "retry"],
    ["timestamp", "createdOn"],
    ["delayed", "delayed"],
    ["finishedIn", "finishedIn"],
    ["failedReason", "failedReason"],
  ];

  const statuses = [
    "active",
    "completed",
    "delayed",
    "failed",
    "paused",
    "waiting",
  ];

  const isDate = (header) =>
    ["timestamp", "processedOn", "finishedOn"].includes(header);

  const calcDelay = (data) =>
    data["processedOn"]
      ? ((data["processedOn"] - data["timestamp"]) / 1000).toFixed(0).toHHMMSS()
      : "";

  const calcDuration = (data) =>
    data["finishedOn"]
      ? ((data["finishedOn"] - data["processedOn"]) / 1000).toFixed(0).toHHMMSS()
      : "";

  return (
    <section>
      <Toolbar error={jobsError} />
      <div className="tablewrapper">
        <table>
          <thead>
            <tr>
              <th>actions</th>
              {headers.map(([name, label]) => (
                <th key={name}>{label}</th>
              ))}
            </tr>
          </thead>
          {statuses.map((status) => (
            <tbody key={status}>
              <tr>
                <td className="subheader" colSpan={headers.length + 1}>
                  {status} ({jobsData[status] ? jobsData[status].length : "0"})
                </td>
              </tr>
              {jobsData[status] &&
                jobsData[status].map((job) => (
                  <tr key={job.id}>
                    <td>
                      {status !== "active" && (
                        <button
                          onClick={() => deleteJob(job.id)}
                          disabled={jobDeleting}
                          style={{ color: "red" }}
                        >
                          Delete
                        </button>
                      )}
                      <button
                        onClick={() => fetchLogs(job.id)}
                        disabled={fetchingLogs}
                        style={{ color: "orangered" }}
                      >
                        Logs
                      </button>
                      {job.returnvalue && typeof job.returnvalue === "string" && (
                        <a
                          target="_blank"
                          href={`/exports/${job.returnvalue}`}
                          rel="noreferrer"
                        >
                          <button style={{ color: "green" }}>Download</button>
                        </a>
                      )}
                    </td>
                    {headers.map(([header]) => (
                      <td className={header} key={job.id + header}>
                        {header === "progress" && (
                          <div
                            className="value"
                            style={{ width: `${job[header]}%` }}
                          ></div>
                        )}
                        {header==="failedReason"&&(job.failedReason&&job.failedReason.includes("Missing lock for job"))?  <div className="content"></div>:
                         <div className="content">
                          {job[header] && isDate(header)
                            ? new Date(job[header]).toLocaleString("ko-KR")
                            : job[header]}
                          {header === "progress" && " %"}
                          {header === "delayed" && calcDelay(job)}
                          {header === "finishedIn" && calcDuration(job)}
                        </div>}
                      </td>
                    ))}
                  </tr>
                ))}
            </tbody>
          ))}
        </table>
      </div>
    </section>
  );
}

export default Jobs;
